import { useEffect } from 'react';
import { studioBOn } from '@/lib/studioB/flag';
import { useEmbeddedIvyChatStore } from '@/stores/embeddedIvyChatStore';
import { composeQueuedMessage, queuedContext, useOutlineEditQueueStore } from '@/stores/outlineEditQueueStore';

/**
 * Direction B (F4): a storyboard send goes to Ivy by itself, at once when she is free, else when her turn ends. It
 * leaves the queue before it is sent, so a second look at the queue never sends it twice. Outline edits and comments
 * still ride with your next message.
 */
export function useStoryboardAutoSend(conversationId: string): void {
  const isStreaming = useEmbeddedIvyChatStore((s) => s.isStreaming);
  const loaded = useEmbeddedIvyChatStore((s) => s.messagesLoaded);
  const items = useOutlineEditQueueStore((s) => s.queuesByConversation[conversationId]);
  useEffect(() => {
    if (!studioBOn() || isStreaming || !loaded) return;
    const batch = (items ?? []).filter((it) => it.kind === 'storyboard-input');
    if (!batch.length) return;
    const queue = useOutlineEditQueueStore.getState();
    batch.forEach((it) => queue.remove(conversationId, it.id));
    void useEmbeddedIvyChatStore.getState().sendMessage(composeQueuedMessage('', batch), queuedContext(batch));
  }, [conversationId, isStreaming, loaded, items]);
}
